/**
 * Authentication API Service
 * Page-specific API handler for authentication
 */

import { apiPost, apiGet, API_ENDPOINTS } from './apiService'
import { showSuccess, showError } from '../utils/toast'

export const authApi = {
  /**
   * Login operator
   * @param {string} email - Operator email
   * @param {string} password - Operator password
   * @returns {Promise} Login response with token and operator data
   */
  async login(email, password) {
    try {
      const result = await apiPost(API_ENDPOINTS.AUTH.LOGIN, { email, password })
      showSuccess('Login successful')
      return result
    } catch (error) {
      showError(error.message || 'Login failed. Please check your credentials.')
      throw error
    }
  },

  /**
   * Get current operator (me)
   * @returns {Promise} Operator data
   */
  async getMe() {
    try {
      return await apiGet(API_ENDPOINTS.AUTH.ME)
    } catch (error) {
      // Don't show error toast for getMe - handled in AuthContext
      throw error
    }
  },

  /**
   * Logout operator
   * @returns {Promise} Logout response
   */
  async logout() {
    try {
      const result = await apiPost(API_ENDPOINTS.AUTH.LOGOUT)
      showSuccess('Logged out successfully')
      return result
    } catch (error) {
      // Even if logout fails, clear local storage
      localStorage.removeItem('operator_token')
      throw error
    }
  },

  /**
   * Refresh token
   * @returns {Promise} New token
   */
  async refreshToken() {
    try {
      return await apiPost(API_ENDPOINTS.AUTH.REFRESH)
    } catch (error) {
      showError('Session expired. Please login again.')
      throw error
    }
  },
}
